import { UI, HStack, Stack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useEffect } from 'react';

import { InputMoney } from '../../../../../../../../../components/InputMoney';
import { TableContentItemText } from '../../../../../../../../../components/TableContent';
import { useDirectTreasuryAssetController } from '../../../../../hooks/products/DirectTreasury';
import { LateralBar } from '../../../components/LateralBar';

import { DirectTreasuryItemSelectedTypes } from '.';

export const DirectTreasuryItemSelectedDesktop: React.FC<DirectTreasuryItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
}) => {
  const id = offer.productIdNormalized;
  const {
    control,
    amountItem,
    currentValue,
    currentValueFormatted,
    handleChangeAmountItem,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
  } = useDirectTreasuryAssetController(offer);

  useEffect(() => {
    if (offer.orderValue === currentValue || !currentValue) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderValue: currentValue || 0,
      orderQuantity: amountItem || 0.01,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  return (
    <UI.List testId="selected-product" height={120}>
      <LateralBar
        backgroundColor={Color['product.tesouro']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <HStack flex={1} justifyContent="space-between">
        <UI.ListItem testId="selected-product-name" title="Produto" stackProps={{ maxW: '1/6' }}>
          <TableContentItemText tooltip={offer.productNameNormalized}>
            {offer.productNameNormalized}
          </TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-application-date" title="Data da aplicação">
          <TableContentItemText>
            {Utils.Mask.DateFormat(new Date(), 'dd/MM/yyyy')}
          </TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-application-in" title="Aplicação em">
          <TableContentItemText>{offer.settlementDateFormattedNormalized}</TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-minimum-investment" title="Investimento mínimo">
          <TableContentItemText>{Utils.Mask.Money(offer.minimumApplication)}</TableContentItemText>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-name" title="Quantidade">
          <Stack pr={Spacing['inline.xxxs']} w="180px">
            <UI.InputStepper
              stepperValue={0.01}
              max={1000000}
              min={offer.minimumStepQuantity || 0}
              name="treasury-amount-order-input"
              testId="treasury-amount-order-input"
              keyboardType="numeric"
              defaultValue={amountItem || 0}
              onChange={handleChangeAmountItem}
              showErrorMessage={false}
            />
          </Stack>
        </UI.ListItem>
        <UI.ListItem testId="selected-product-name" title="Valor a aplicar">
          <Stack pr={Spacing['inline.xxxs']} w="180px">
            <InputMoney
              id={`directTreasury-input${id}`}
              name="priceItem"
              control={control}
              handleFocus={handleInputFocus}
              handleBlur={handleInputBlur}
              handleSubmit={handleSubmit}
              handleClear={handleInputClear}
              currentValue={currentValueFormatted}
              hasFocus={isFocused}
              minValue={offer.minimumApplication || 0}
              customInputProps={{
                ...{
                  ...(showMessageAdjustUnitPrice && {
                    helpTextProps,
                    helpText,
                  }),
                },
                ...{ ...(isFocused && hasError && { error: hasError }) },
                ...{ ...(isFocused && !hasError && { helpText }) },
              }}
            />
          </Stack>
        </UI.ListItem>
      </HStack>
    </UI.List>
  );
};
